<template>
  <div class="workingClassPerson">
    <Header title="选课名单"></Header>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="xh" label="学号" fixed="left"> </el-table-column>
      <el-table-column prop="xm" label="姓名"> </el-table-column>
      <el-table-column prop="bj" label="班级"> </el-table-column>
      <el-table-column prop="zymc" label="专业"> </el-table-column>
      <el-table-column prop="dqszj" label="年级"> </el-table-column>
      <el-table-column prop="dwmc" label="院系"> </el-table-column>
      <el-table-column prop="xsbz" label="备注"> </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { Api } from "../../../../utils/axios";
export default {
  data() {
    return {
      tableData: []
    };
  },
  created() {
    let jx0404id = this.$route.query.jx0404id;
    console.log(jx0404id);
    this.getPerson(jx0404id);
  },
  methods: {
    async getPerson(jx0404id) {
      const res = await Api.getxsmd({
        jx0404id: jx0404id
      });
      this.tableData = res.data;
    }
  }
};
</script>

<style lang="less" scoped>
.workingClassPerson {
  padding: 0 20px;
}
</style>
<style lang="less">
.workingClassPerson {
  .el-table td {
    border-bottom: 1px solid #ebeef5 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/studentInfo/info.vue